import apiClient from './api';

export interface PaymentCheckout {
  type?: string;
  data?: Record<string, string>;
}

export interface PaymentView {
  paymentId: string;
  status: string;
  provider?: string;
  amountPaise: number;
  currency?: string;
  txnid?: string;
  shareUrl?: string;
  providerOrderId?: string;
  checkout?: PaymentCheckout;
  message?: string;
  /** Set when the capture was not applied to the order (e.g. AMOUNT_MISMATCH) and is being refunded. */
  attentionReason?: string | null;
}

export async function createGuestPayment(body: {
  restroId: number;
  orderId: number;
  checkoutMode?: string;
  /** Absolute URL for hosted checkout return (kiosk confirmation). */
  returnUrl?: string;
}): Promise<PaymentView> {
  const { data } = await apiClient.post('/api/payments', body);
  return data;
}

export async function confirmGuestPayment(
  paymentId: string,
  body: { orderId?: string; paymentId?: string; signature?: string }
): Promise<PaymentView> {
  const { data } = await apiClient.post(`/api/payments/${paymentId}/confirm`, body);
  return data;
}

export async function refreshGuestPayment(paymentId: string): Promise<PaymentView> {
  const { data } = await apiClient.post(`/api/payments/${paymentId}/refresh`);
  return data;
}

export async function abandonGuestPayment(
  paymentId: string,
  reason: 'FAILED' | 'CANCELLED'
): Promise<PaymentView> {
  const { data } = await apiClient.post(`/api/payments/${paymentId}/abandon`, { reason });
  return data;
}

const OPEN_PAYMENT_STATUSES = new Set(['CREATED', 'PENDING', 'AUTHORIZED']);

export function isOpenPaymentStatus(status?: string | null): boolean {
  return OPEN_PAYMENT_STATUSES.has((status || '').toUpperCase());
}

export async function getOrderPayment(orderId: number, restroId: number): Promise<PaymentView | null> {
  try {
    const { data } = await apiClient.get<PaymentView>(`/api/payments/by-order/${orderId}`, {
      params: { restroId },
    });
    return data ?? null;
  } catch {
    return null;
  }
}
